export interface ParadaItinerario {
  id?: string
  tarifarioId?: string
  ordem: number
  trecho?: string | null
  areaTarifario?: string | null
  localParada?: string | null
  descricao?: string | null
  cep?: string | null
  logradouro?: string | null
  numero?: string | null
  bairro?: string | null
  complemento?: string | null
  cidade?: string | null
  estado?: string | null
  latitude?: number | null
  longitude?: number | null
  horaParada?: string | null
  tempoPermanencia?: string | null
  atividades?: string | null
  dataCriacao?: string
  horaCriacao?: string
  criadoPor?: number
}

export class TarifarioForkRequest {
  public itemPropostaId?: number | string
  public paradas: ParadaItinerario[] = []
}

export interface TarifarioVm {
  id: string
  tipoId: number
  tipoTarifario?: string
  origemId: number
  origem?: string
  cidadeOrigem?: string
  estadoOrigem?: string
  paisOrigem?: string
  destinoId: number
  destino?: string
  cidadeDestino?: string
  estadoDestino?: string
  paisDestino?: string
  tipoServicoId: number
  tipoServico?: string
  servicoId: number
  servico?: string
  tipoVeiculoId?: number
  tipoVeiculo?: string
  tipoMotoristaId?: number
  tipoMotorista?: string
  fornecedorId?: number
  fornecedor?: string
  custo: number
  custoHoraExtra: number
  custokmExtra: number
  dataCriacao?: string
  horaCriacao?: string
  import?: string
  ativo: string
  dataValidade?: string
  clienteId?: number
  cliente?: string
  subCliente?: string
  usuarioId?: number
  login?: string
  pessoaId?: number
  usuario?: string
  perimetroUrbano?: string
  standard?: string
  paradas?: ParadaItinerario[]
}

export function paradaToItinerarioItemProposta(p: ParadaItinerario): any {
  return {
    localParada: p.localParada ?? '',
    descricao: p.localParada ?? '',
    cep: p.cep ?? '',
    logradouro: p.logradouro ?? '',
    numero: p.numero ?? '',
    bairro: p.bairro ?? '',
    complemento: p.complemento ?? '',
    cidade: p.cidade ?? '',
    estado: p.estado ?? '',
    latitude: p.latitude ?? null,
    longitude: p.longitude ?? null,
    trecho: p.trecho ?? 'P',
    areaTarifario: p.areaTarifario ?? 'N',
    horaParada: p.horaParada ?? '',
    tempoPermanencia: p.tempoPermanencia ?? '',
    atividades: p.atividades ?? '',
  }
}

export function paradasIdentityKey(p: ParadaItinerario): string {
  return [
    p.trecho ?? '',
    p.localParada ?? '',
    p.cep ?? '',
    p.logradouro ?? '',
    p.numero ?? '',
    p.bairro ?? '',
    p.complemento ?? '',
    p.cidade ?? '',
    p.estado ?? '',
    p.latitude ?? '',
    p.longitude ?? '',
    p.horaParada ?? '',
    p.tempoPermanencia ?? '',
    p.atividades ?? '',
  ].join('|')
}

export function paradasDivergem(
  a: ParadaItinerario[],
  b: ParadaItinerario[],
): boolean {
  if ((a?.length ?? 0) !== (b?.length ?? 0)) return true
  const sortedA = [...a].sort((x, y) => x.ordem - y.ordem)
  const sortedB = [...b].sort((x, y) => x.ordem - y.ordem)
  for (let i = 0; i < sortedA.length; i++) {
    if (paradasIdentityKey(sortedA[i]) !== paradasIdentityKey(sortedB[i])) {
      return true
    }
  }
  return false
}
